// Traction and validation section configuration
// Defines fields for user/customer metrics and growth
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for traction section
export const tractionSectionSchema = z.object({
  hasActiveUsers: z.string().min(1, 'Este campo es requerido'),
  hasPayingCustomers: z.string().min(1, 'Este campo es requerido'),
  currentUserCount: z.string().min(1, 'Este campo es requerido'),
  userGrowthRate: z.string().min(1, 'Este campo es requerido'),
  activeEngagements: z.array(z.string()).optional(),
});

export type TractionSectionData = z.infer<typeof tractionSectionSchema>;

// Section config
export const tractionSection: SectionConfig = {
  id: 'traction',
  titleKey: 'Tracción y validación',
  descriptionKey: 'Métricas de usuarios, clientes y crecimiento',
  validationSchema: tractionSectionSchema,
  fields: [
    {
      name: 'hasActiveUsers',
      type: 'radio',
      label: '¿Tienes usuarios activos?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
      ],
    },
    {
      name: 'hasPayingCustomers',
      type: 'radio',
      label: '¿Tienes clientes que pagan?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
      ],
    },
    {
      name: 'currentUserCount',
      type: 'radio',
      label: '¿Cuántos usuarios/clientes tienes actualmente?',
      required: true,
      options: [
        { value: '1-10', label: '1-10' },
        { value: '10-30', label: '10-30' },
        { value: '30-50', label: '30-50' },
        { value: '50-100', label: '50-100' },
        { value: '100-500', label: '100-500' },
        { value: '500+', label: '+500' },
      ],
    },
    {
      name: 'userGrowthRate',
      type: 'radio',
      label: '¿Cuál ha sido el crecimiento de usuarios activos (MAU) en los últimos 3 meses?',
      required: true,
      options: [
        { value: '0', label: '0% (sin crecimiento)' },
        { value: '1-10', label: '1%-10%' },
        { value: '11-25', label: '11%-25%' },
        { value: '26-50', label: '26%-50%' },
        { value: '51-100', label: '51%-100%' },
        { value: '100+', label: 'Más de 100%' },
      ],
    },
    {
      name: 'activeEngagements',
      type: 'multiselect',
      label: '¿Tienes alguna de estas activa?',
      required: false,
      options: [
        { value: 'pilots', label: 'Pilotos' },
        { value: 'trials', label: 'Pruebas' },
        { value: 'contracts', label: 'Contratos activos' },
      ],
    },
  ],
};
